import { deconstructNode } from '~/libs/contentful/helpers'
import { TypeSalaryByLocation } from '~/types/contentful/TypeSalaryByLocation'
import { useState } from 'react'
import classNames from 'classnames'
import { useLoaderData } from '@remix-run/react'
import { JobTitlePageLoaderData } from '~/routes/careers.$slug.$type'

type SalaryByLocationProps = {
  salaryByLocation: TypeSalaryByLocation<'WITHOUT_UNRESOLVABLE_LINKS', string>
}
const TABS = [
  { id: 'city', name: 'City' },
  { id: 'state', name: 'State' },
]

export const SalaryByLocation = ({ salaryByLocation }: SalaryByLocationProps) => {
  const { salaryData } = useLoaderData() as Pick<JobTitlePageLoaderData, 'salaryData'>
  if (!salaryData) return null

  const { top_cities_salary, top_states_salary } = salaryData.data

  const { fields } = deconstructNode(salaryByLocation) as TypeSalaryByLocation<
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >
  const { jobTitle } = fields
  const [selectedTab, setSelectedTab] = useState('city')
  return (
    <div className="flex flex-col items-start gap-3 self-stretch mt-12">
      <span className="text-m text-neutral-100 self-stretch">{jobTitle} Salary by Location</span>
      <div className="flex items-center justify-start self-stretch border-b border-neutral-20 first:ml-0 last:mr-0 gap-8">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setSelectedTab(tab.id)}
            className={classNames(
              'flex py-3 justify-center items-center text-xs',
              selectedTab === tab.id
                ? 'border-b-2 border-blue-50 text-neutral-100'
                : 'text-neutral-60',
            )}
          >
            {tab.name}
          </button>
        ))}
      </div>
      <ul className="flex flex-col items-start gap-3 w-full max-w-xl">
        {selectedTab === 'city' &&
          top_cities_salary.map(([city, salary], index) => (
            <li
              key={index}
              className="flex py-2 px-4 items-center justify-between gap-2 rounded bg-blue-10 text-xs text-neutral-100"
              style={{ width: `${(salary / top_cities_salary[0][1]) * 100}%` }}
            >
              <div className="flex items-center gap-1">
                <span className="text-neutral-60">{index + 1}.</span>
                <span>{city}</span>
              </div>
              <span>${salary}</span>
            </li>
          ))}
        {selectedTab === 'state' &&
          top_states_salary.map(([state, salary], index) => (
            <li
              key={index}
              className="flex py-2 px-4 items-center justify-between gap-2 rounded bg-blue-10 text-xs text-neutral-100"
              style={{ width: `${(salary / top_states_salary[0][1]) * 100}%` }}
            >
              <div className="flex items-center gap-1">
                <span className="text-neutral-60">{index + 1}.</span>
                <span>{state}</span>
              </div>
              <span>${salary}</span>
            </li>
          ))}
      </ul>
      <span className="text-[16px] leading-5 text-neutral-60 self-stretch">
        Note: Salary data is based on average compensation and may vary based on company size,
        industry, and other factors.
      </span>
    </div>
  )
}
